var _div;
import { Skeleton } from '@crehana/compass.ui/skeleton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var LoadingContent = function LoadingContent() {
  return _div || (_div = /*#__PURE__*/_jsxs("div", {
    className: "tw-w-full tw-flex tw-flex-col tw-items-center tw-gap-2.4",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-w-full tw-justify-between tw-items-center",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-20 tw-h-3.2 tw-rounded-1"
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-24 tw-h-3.2 tw-rounded-1"
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-full tw-h-[16rem] tw-rounded-1"
    }), /*#__PURE__*/_jsx("div", {
      className: "tw-w-full",
      children: /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-28.8 tw-h-3.2 tw-rounded-1"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-wrap tw-justify-center tw-gap-1.2",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-11.2 lg:tw-w-20  tw-h-3.2 tw-rounded-[8rem]"
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-11.2 lg:tw-w-20 tw-h-3.2 tw-rounded-[8rem]"
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-11.2 lg:tw-w-20 tw-h-3.2 tw-rounded-[8rem]"
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-11.2 lg:tw-w-20 tw-h-3.2 tw-rounded-[8rem]"
      })]
    }), /*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-28.8 tw-h-3.2 tw-rounded-1"
    })]
  }));
};